// extracted by mini-css-extract-plugin
export default {"container":"LogPrompt_container__przhn"};